<template>
  <div class="flex min-h-[50vh]">
    <div class="container py-16 m-auto text-center w-full">
      <div class="mb-12 pb-6 bg-[#f7f7fe] rounded-md" v-if="typeform?.props">
        <div v-bind="typeform.props"></div>
      </div>
      <div class="max-w-lg text text-lg mb-8 text-gray-700 mx-auto">
        <h1 class="text-blue-500">Vielen Dank für Ihre Bestellung</h1>
        <p>
          Bei Fragen zu Ihrer Bestellung oder Hinweisen zu Ihrem Theaterbesuch (Sie benötigen bspw. aufgrund einer Gehbehinderung oder anderer körperlicher Einschränkungen einen Sitzplatz in der ersten Reihe) erreichen Sie uns uns unter
          <a href="tel:0049241161688">0241 161688</a>
          oder per E-Mail unter
          <a :href="`mailto:shop@dasda.de?subject=Referenznummer ${order.number}`">shop@dasda.de</a>.
        </p>
        <p>
          Ihre Referenznummer lautet <strong class="select-all text-blue-500">{{ order.number }}</strong>.
        </p>
        <h2 class="text-blue-500">Sie wünschen eine Ticketversicherung?</h2>
        <p>
           Dazu können Sie sich gerne eigenständig unter folgendem <a href="https://www.reisepolice.com/ticketversicherung.html" target="_blank">Link</a> informieren und eine Versicherung Ihrer Wahl abschließen.
        </p>
      </div>
      <Link
        :href="route('home')"
        class="button"
        text="Zur Startseite"
      />
    </div>
  </div>
</template>

<script>
import Layout from 'Web/Layouts/Default.vue';
import Link from 'Web/Shared/Link.vue';
import useMeta from '@/compose/meta';

export default {
  inheritAttrs: false,
  layout: Layout,
  components:{
    Link,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    typeform: {
      type: Object,
      required: false,
    },
  },
  setup(props) {
    const { assign } = useMeta();

    assign({ title: 'DAS DA-Onlineshop - Danke' });

    if (props.typeform?.script) {
      const typeformScript = document.createElement('script');
      typeformScript.setAttribute('src', props.typeform.script);
      document.head.appendChild(typeformScript);
    }
  }
}
</script>
